<div class="placeholders">
    <fui-alerts></fui-alerts>
</div>

<wbo-login-podium>
    <div class="profile">
        <div class="profile-header">
            <div class="profile-header-media">
                <div class="profile-header-media-object">
                    <fui-pos-logo id="logo" [type]="'fedelta'"></fui-pos-logo>
                </div>
            </div>
            <div *ngIf="loaded" class="profile-header-title">{{'wbo.user-profile-completion.title' | translate}}</div>
            <div *ngIf="!loaded" class="profile-header-title">{{'wbo.user-profile-completion.message.loading' | translate}}</div>
        </div>
        <div class="profile-main" *ngIf="loaded">
            <form class="form" id="user-profile" name="form" (ngSubmit)="proceed()">
                <div class="form-main" [formGroup]="formGroup">
                    <div class="form-fields">
                        <div class="form-fields-field">
                            <fui-text-control id="email" [label]="'wbo.user-profile-completion.label.email'"
                                              formControlName="email" [control]="formGroup.get('email')"
                                              [(ngModel)]="profileModel.data.employee.contact.email"
                                              [placeholder]="'wbo.user-profile-completion.placeholder.email'">
                            </fui-text-control>
                        </div>
                        <div class="form-fields-field">
                            <fui-text-control id="mobile" [label]="'wbo.user-profile-completion.label.mobile'"
                                              formControlName="mobile" [control]="formGroup.get('mobile')"
                                              [(ngModel)]="profileModel.data.employee.contact.mobilePhone"
                                              [placeholder]="'wbo.user-profile-completion.placeholder.mobile'">
                            </fui-text-control>
                        </div>
                    </div>
                </div>
                <div class="form-actions">
                    <div class="form-actions-action">
                        <fui-submit-button id="logout-button" (click)="logout()" class="form-actions-action-logout"
                                           [title]="'wbo.user-profile-completion.button.logout'"></fui-submit-button>
                    </div>
                    <div class="form-actions-action">
                        <fui-submit-button id="proceed-button" class="form-actions-action-proceed"
                                           [title]="'wbo.user-profile-completion.button.proceed'"></fui-submit-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</wbo-login-podium>
